import { render, staticRenderFns } from "./addVehicle.vue?vue&type=template&id=477ea8c8&scoped=true"
import script from "./addVehicle.vue?vue&type=script&lang=js"
export * from "./addVehicle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477ea8c8",
  null
  
)

export default component.exports